import type { PoDocumentUploadedNotificationConfig } from '../../../../domain/types/configs/company/NotificationConfig';

export const poDocumentUploadedNotificationConfig: PoDocumentUploadedNotificationConfig = {
  recipients: [
    {
      send: true,
      contact: "ap@cooweb.co",
      company: "FRESENIUS"
    },
    {
      company: "FRESENIUS",
      send: true,
      contact: "sonia.vanegas@dawipo.com"
    }
  ]
}; 